import api from "./api";

export interface Consignee {
  _id?: string;
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  phoneNumber: string;
  email?: string;
  taxId?: string;
  consigneeReference?: string;
  notes?: string;
  active?: boolean;
}

export const consigneeService = {
  getAllConsignees: async (): Promise<Consignee[]> => {
    const response = await api.get("/consignees");
    return response.data;
  },

  getConsigneeById: async (id: string): Promise<Consignee> => {
    const response = await api.get(`/consignees/${id}`);
    return response.data;
  },

  createConsignee: async (consignee: Consignee): Promise<Consignee> => {
    const response = await api.post("/consignees", consignee);
    return response.data;
  },

  updateConsignee: async (id: string, consignee: Consignee): Promise<Consignee> => {
    const response = await api.put(`/consignees/${id}`, consignee);
    return response.data;
  },

  deleteConsignee: async (id: string): Promise<void> => {
    await api.delete(`/consignees/${id}`);
  },

  downloadTemplate: async (): Promise<void> => {
    const response = await api.get("/consignees/template/download", {
      responseType: "blob",
    });

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'consignees_template.csv');

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
    window.URL.revokeObjectURL(url);
  },

  upload: async (file: File): Promise<any> => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post("/consignees/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  // Keep the old method name for backward compatibility
  uploadConsignees: async (file: File): Promise<any> => {
    return consigneeService.upload(file);
  },

  downloadAll: async (): Promise<void> => {
    const response = await api.get("/consignees/download/all", {
      responseType: "blob",
    });

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    // Set filename with timestamp
    const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
    link.setAttribute('download', `consignees_export_${timestamp}.csv`);

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
    window.URL.revokeObjectURL(url);
  },

  // Keep the old method name for backward compatibility
  downloadAllConsignees: async (): Promise<void> => {
    return consigneeService.downloadAll();
  },
};
